export const DEFAULT_LOCALE = "en-US";

export const DUMMY_MODEL_ID = "NEW_MODEL";

export const PAGINATION_OPTIONS = [10, 50, 100, 200];

export const INCIDENT_DESCRIPTION_COLUMN_NAME = "incident_description";

export const INCIDENT_ID_COLUMN_NAME = "incident_id";

export const CPT_AUDITOR_LDAP_GROUP = "whs-data-excavator-auditor-cpt";

export const CPT_AUDITOR_ADMIN_LDAP_GROUP = "whs-data-excavator-auditor-cpt-admin";

export const VLM_AUDITOR_LDAP_GROUP = "whs-data-excavator-vlm-beta-tester";

// Federate only releases a fixed set of LDAP groups into the token claim, and the
// VLM beta-tester team group is not among them, so group membership cannot gate the
// VLM Audit Workflow yet. Gate on this alias allowlist until the group is federated.
export const VLM_BETA_TESTER_ALIASES = [
  "augusjos",
  "cairuoya",
  "cshalin",
  "minxup",
  "sujianwe",
  "wwangam",
  "yukhuang",
];

export const GENERAL_USER_LDAP_GROUP = "whs-data-excavator-user";

export const ADMIN_LDAP_GROUP = "whs-data-excavator-admin";

export const ENGINEER_LDAP_GROUP = "workingwell-engineer";

export const AUDITOR_VIEWER_LDAP_GROUP = "whs-data-excavator-auditor-viewer";

// Mirrors the backend AUDIT_READ_LDAP_GROUPS (constants.py): the groups allowed to
// call the audit read APIs, including GET /audit_access/me. Keep in sync.
export const AUDIT_READ_LDAP_GROUPS = [
  AUDITOR_VIEWER_LDAP_GROUP,
  CPT_AUDITOR_LDAP_GROUP,
  CPT_AUDITOR_ADMIN_LDAP_GROUP,
  ADMIN_LDAP_GROUP,
  ENGINEER_LDAP_GROUP,
];

// Mirrors the backend SDS_DATA_SOURCE name (batch_inference_job_config.py).
export const SDS_DATA_SOURCE_NAME = "SDS";

export const SOURCE_ID = "source_id";

export const SOURCE_TEXT = "source_text";

export const INADEQUATE_INFORMATION = "Inadequate Information";

export const NO_OBJECT_INVOLVED = "No object involved";

export const OTHER = "Other";

export const HIERARCHY_SEPARATOR = "---";
